import type { PunchKey } from './types';

export type Turno = 'diurno' | 'noturno';

/** Espelha supabase/functions/_shared/schedule.ts — mesma regra de negócio,
 * usada aqui só para exibir a prévia do horário antes da confirmação. O
 * servidor recalcula de forma independente ao gravar o registro. */
const OFFSETS_MIN = {
  noturno: { entrada: 3, saida_descanso: 10, volta_descanso: 10, saida: 8 },
  diurno: { entrada: 8, saida_descanso: 9, volta_descanso: 9, saida: 9 },
} as const;

function parseHM(hm: string): number {
  const [h, m] = hm.split(':').map(Number);
  return h * 60 + m;
}
function toHM(totalMin: number): string {
  const norm = ((totalMin % 1440) + 1440) % 1440;
  const h = Math.floor(norm / 60);
  const m = norm % 60;
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

export function computeHorarioForTipo(turno: Turno, entradaAncora: string, tipo: PunchKey): string {
  const ancoraMin = parseHM(entradaAncora);
  const off = OFFSETS_MIN[turno];
  const totalMin = {
    entrada: ancoraMin + off.entrada,
    saida_descanso: ancoraMin + 4 * 60 + off.saida_descanso,
    volta_descanso: ancoraMin + 5 * 60 + off.volta_descanso,
    saida: ancoraMin + (turno === 'noturno' ? 11 : 9) * 60 + off.saida,
  }[tipo];
  return toHM(totalMin);
}
